/* eslint-disable react/no-multi-comp */

import { Box, Button, SxProps, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';

import CustomDatePicker from 'src/components/NPIDateRangePicker/CustomDatePicker';

type DateFilterMenuItemProps = {
    title: string;
    fromDate: Dayjs | null;
    toDate: Dayjs | null;
    handleFromDateChange: (newDate: Dayjs | null) => void;
    handleToDateChange: (newDate: Dayjs | null) => void;
    onClearFilter: () => void;
};

type LabeledDatePickerProps = {
    label: string;
    value: Dayjs | null;
    onChange: (newDate: Dayjs | null) => void;
    sx?: SxProps;
};

function LabeledDatePicker(props: LabeledDatePickerProps) {
    const { label, value, onChange, sx } = props;

    return (
        <Box display="flex" flexDirection="column" flex={1}>
            <Typography color="text.secondary" fontSize="0.9rem" mb={0.5}>
                {label}
            </Typography>
            <CustomDatePicker value={value} onChange={onChange} sx={sx} />
        </Box>
    );
}

export default function DateFilterMenuItem({
    title,
    fromDate,
    toDate,
    handleFromDateChange,
    handleToDateChange,
    onClearFilter,
}: DateFilterMenuItemProps) {
    const containerStyles: SxProps = {
        borderBottom: '1px solid #E5E5E5',
        display: 'flex',
        flexDirection: 'column',
        width: 400,
        padding: '10px 20px',
    };

    const datePickerStyles: SxProps = {
        '.MuiInputBase-input': { height: '9px' },
        '.MuiInputBase-root': { height: '40px' },
        '.MuiOutlinedInput-root': {
            '& fieldset': { borderColor: '#E5E5E5' },
            '&:hover fieldset': { borderColor: '#E5E5E5' },
        },
    };

    return (
        <Box sx={containerStyles}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography sx={{ color: '#000000' }} fontWeight={400} fontSize={14}>
                    {title}
                </Typography>
                <Button
                    onClick={onClearFilter}
                    sx={{
                        textTransform: 'none',
                        color: '#444444',
                        fontSize: '0.9rem',
                    }}
                >
                    Clear
                </Button>
            </Box>

            <Box display="flex" alignItems="center" gap={2}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <LabeledDatePicker
                        label="From:"
                        value={fromDate}
                        onChange={handleFromDateChange}
                        sx={datePickerStyles}
                    />
                    <LabeledDatePicker
                        label="To:"
                        value={toDate}
                        onChange={handleToDateChange}
                        sx={datePickerStyles}
                    />
                </LocalizationProvider>
            </Box>
        </Box>
    );
}
